import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

/**
 * How many schedule assignments route to a trade (FIQ-2457). Readable without the schedule
 * assignments flag, for the trade removal warning.
 */
export const skillMapTradeAssignmentCount = api(async function skillMapTradeAssignmentCount({ skillMapId, tradeId }) {
    return query(
        gql`
            query GetSkillMapTradeAssignmentCount($skillMapId: String!, $tradeId: String!) {
                skillMapTradeAssignmentCount(skillMapId: $skillMapId, tradeId: $tradeId)
            }
        `,
        { skillMapId, tradeId },
        { returns: "skillMapTradeAssignmentCount", fetchPolicy: "network-only" }
    )
})
